import { render, staticRenderFns } from "./user_other_links.vue?vue&type=template&id=121cbfd2&scoped=true"
import script from "./user_other_links.vue?vue&type=script&lang=js"
export * from "./user_other_links.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121cbfd2",
  null
  
)

export default component.exports